import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router} from '@angular/router';


declare var $:any;

@Injectable()
export class RouteNavigationService {
    
    imageObject: any;

    constructor(private http: HttpClient, 
        private router: Router
    ) { }

    public navigate(route, page) {
        this.router.navigate(
            [], 
            {
              relativeTo: route,
              queryParams: { page: page},
              queryParamsHandling: 'merge'
        });
    }
    
}

   